import React from 'react';

// Numbered avatar for a goal — the 1-based position passed in by GoalsTab.
interface ComponentProps {
  number: number;
}

const GoalNumberAvatar: React.FC<ComponentProps> = ({ number }) => (
  <span className="care-plan-goal-number" data-cy={`care-plan-goal-number-${number}`}>
    {number}
  </span>
);

export default GoalNumberAvatar;
